import React from "react";
class Helmet1 extends React.Component {

  render() {
    return (
      <div
      className="Helmet1"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        height: "100vh",
        width: "100vw",
        background: "rgba(255, 255, 255)",
        // background: "red",
        zIndex: 100,
      }}
    ></div>
  //   <div
  //   className="d-flex justify-content-center align-items-center"
  //   style={{ height: "100vh" }}
  // >
  //   <div className="loader">Loading...</div>
  // </div>


    );
  }
}

export default Helmet1;
